export default __webpack_public_path__ + "static/media/img11.80900d73.jpg";